"use client";
import { useState } from "react";

const Faq = ({ faqData }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const safeFaqData = Array.isArray(faqData) ? faqData : [];

  return (
    <>
      {safeFaqData.map((faq, index) => (
        <div
          key={index}
          className={`faqCard ${activeIndex === index ? "active" : null}`}
        >
          <button className="faqHeader" onClick={() => handleClick(index)}>
            <span> {faq?.title}</span>
            <div className="minus"></div>
          </button>
          <div className={`faqBody ${activeIndex === index ? "open" : ""}`}>
            <div dangerouslySetInnerHTML={{ __html: faq?.content }} />
          </div>
        </div>
      ))}
    </>
  );
};

export default Faq;
